/** Module keys — must match route meta `module`, AppMenu `name`, and backend deployment settings. */
export type AppModule =
    | 'integration-lab'
    | 'ps-customer-server'
    | 'ps-estimate'
    | 'license-tracker'
    | 'site-assessment'
    | 'patient-tile-composer'
    | 'mp1-data-analyzer'
    | 'ddi-library'
    | 'master-variable'
    | 'data-sync'
    | 'gateway-management'
    | 'unit'
    | 'go-live-generator'
    | 'cables-lookup';

export const APP_MODULES: AppModule[] = [
    'integration-lab',
    'ps-customer-server',
    'ps-estimate',
    'license-tracker',
    'site-assessment',
    'patient-tile-composer',
    'mp1-data-analyzer',
    'ddi-library',
    'master-variable',
    'data-sync',
    'gateway-management',
    'unit',
    'go-live-generator',
    'cables-lookup',
];

export const moduleLabels: Record<AppModule, string> = {
    'integration-lab': 'Integration Lab',
    'ps-customer-server': 'PS Customer Server',
    'ps-estimate': 'PS Estimate',
    'license-tracker': 'License Tracker',
    'site-assessment': 'Site Assessment',
    'patient-tile-composer': 'Patient Tile Designer',
    'mp1-data-analyzer': 'MP1 Data Analyzer',
    'ddi-library': 'DDI Library',
    'master-variable': 'Master Variable',
    'data-sync': 'Data Sync',
    'gateway-management': 'Gateway Management',
    'unit': 'Unit',
    'go-live-generator': 'Go-Live Generator',
    'cables-lookup': 'Cable Compatibility Lookup',
};

export const defaultModuleDeploymentSettings: Record<
    AppModule,
    {
        visibleToAll: boolean;
        underMaintenance: boolean;
        allowedUserEmails: string[];
        maintenanceBypassEmails: string[];
    }
> = {
    'integration-lab': { visibleToAll: true, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'ps-customer-server': { visibleToAll: true, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'ps-estimate': { visibleToAll: true, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'license-tracker': { visibleToAll: false, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'site-assessment': { visibleToAll: true, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'patient-tile-composer': { visibleToAll: false, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'mp1-data-analyzer': { visibleToAll: false, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'ddi-library': { visibleToAll: false, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'master-variable': { visibleToAll: false, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'data-sync': { visibleToAll: false, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'gateway-management': { visibleToAll: false, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'unit': { visibleToAll: false, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'go-live-generator': { visibleToAll: true, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
    'cables-lookup': { visibleToAll: true, underMaintenance: false, allowedUserEmails: [], maintenanceBypassEmails: [] },
};
